<template>
  <div>
    <top></top>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="评选说明" name="first">
          <div class="appraise">
            <p class="appraise-title">评选说明</p>
            <p class="appraise-detail" v-html="appraiseList"></p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="品牌展示" name="third">
          <div class="logo">
            <p class="logo-title">品牌展示</p>
            <ul>
              <li v-for="(list, index) in brandList">
                <div class="logo-message">
                  <p class="logo-name">{{ list.name }}</p>
                  <img :src="list.logo" />
                  <p class="logo-proname">{{ list.ms }}</p>
                </div>
              </li>
            </ul>
            <h1 style="color:#d61518;text-align: center;" v-show="shows">敬请期待！</h1>
          </div>
          <!-- 分页 -->
          <!-- <el-pagination
        class="paging"
        background
        layout="prev, pager, next"
        :total="1000"
      >
      </el-pagination> -->
        </el-tab-pane>
      </el-tabs>
      <div
        class="home"
        @click="home"
        @mouseover="mouseOver"
        @mouseleave="mouseLeave"
      >
        <img src="../assets/icon/home.png" alt="返回首页" :style="Over" />
        <p class="" :style="Leave">返回首页</p>
      </div>

    </div>

    <tail></tail>
  </div>
</template>

<script>
import top from "./top";
import tail from "./tail";
import { trend } from "../api/api";
export default {
  components: {
    top: top,
    tail: tail,
  },
  data() {
    return {
      activeName: "first",
      appindex: 0, //评选说明下标ID
      bandId: 0, //品牌展示ID
      appraiseList: [],
      Over: "",
      Leave: "",
     shows:false,
      brandList: [
        {
          id: 0,
          logo: "",
          ms: "",
          name: "",
        },
      ],
    };
  },
  mounted() {
    //点击回到顶部
    window.addEventListener("scroll", this.showbtn, true);
    //接收父组件传值，赋值显示评选说明下标
    this.appindex = this.$route.params.imgId;
    //根据父组件传过来的值查找对应的评选内容
    this.getData();
    this.getData1();
  },
  methods: {
    //获取品牌展示数据
    getData: function () {
      var gain = {
        cate_id: this.$route.params.cate_id,
        where: "[year,=,2021]",
        //where: "[leixin,%,"+视频监控+"]",
        //limit: 40,
      };
      trend(gain).then((res) => {
     
        if(res.data.list==0){
          this.shows=true;

        }
        this.brandList = res.data.list;
        console.log(this.brandList)
      });
    },
    //获取评选说明数据
    getData1: function () {
      var gain = {
        cate_id: 111,
        where: "[year,=,2021]",
      };
      trend(gain).then((res) => {
        this.appraiseList = res.data.list[this.appindex].content;
      });
    },
    home: function () {
      this.$router.push({ name: "index" });
    },
    mouseOver() {
      this.Over = "display: none";
      this.Leave = "display: block";
      //改变样式
    },
    mouseLeave() {
      //清空样式
      this.Over = "display: block";
      this.Leave = "display: none";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff0000;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff0000;
}
/deep/.el-tabs__item:hover {
  color: #df2a2a;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #df2a2a;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #df2a2a;
  border-color: #df2a2a;
}
/deep/ .el-tabs__header {
  background: #fff;
  height: 48px;
}
/deep/ .el-tabs__active-bar {
  width: 350px;
}
/deep/ .el-tabs__item {
  width: 600px;
  text-align: center;
  height: 48px;
  line-height: 48px;
}
/deep/ .el-tabs__active-bar {
  height: 3px;
}
/deep/ .el-tabs__item.is-active {
  color: #df2a2a;
}
/deep/ .el-tabs__active-bar {
  background-color: #df2a2a;
  width: 600px;
  margin-left: 10px;
}
/deep/ .el-tabs__nav {
  height: 48px;
}
/deep/.el-tabs__content {
  margin-bottom: 30px;
}

.content {
  width: 1200px;
  margin: 20px auto;
  background: #fff;
  padding-bottom: 30px;
  .appraise {
    padding: 20px 45px;
    .appraise-title {
      text-align: center;
      font-size: 20px;
      margin-bottom: 20px;
      color: #1a1a1a;
    }
    .appraise-detail {
      font-size: 16px;
      text-align: justify;
    }
    .unfold {
      margin-left: 1040px;
    }
  }
  .logo {
    background: #fff;
    margin-top: 15px;
    margin-bottom: 30px;
    padding: 20px 22px;
    .logo-title {
      text-align: center;
      font-size: 20px;
      color: #1a1a1a;
      margin-bottom: 15px;
    }
    .paging {
      text-align: center;
      margin-top: 20px;
    }
    ul {
      text-align: center;
      li {
        display: inline-block;
        float: left;
        .logo-message {
          width: 225px;
          // height: 105px;
          padding: 10px 0px;
          background: #fff;
          border: 1px solid #eeeeee;
          text-align: center;
          font-size: 12px;
          margin: 10px 10px;
          padding: 20px;
          .logo-name {
            font-size: 18px;
            color: #333333;
            font-weight: 600;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          img {
            display: inline-block;
            margin: 0 auto;
            width: 100%;
            margin: 15px 0px;
          }
          .logo-proname {
            font-size: 14px;
            color: #666666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height: 38px;
          }
        }
      }
    }
  }
  .home {
    position: fixed;
    margin-left: 650px;
    left: 50%;

    bottom: 10%;
    cursor: pointer;
    width: 60px;
    height: 60px;
    color: #ffffff;
    font-weight: bold;
    background-color: #d61518;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      display: block;
      margin: 0 auto;
    }
    p {
      text-align: center;
      font-size: 20px;
      color: #d61518;
      display: none;
      letter-spacing: 1px;
    }
  }
  .home:hover {
    background-color: #ffffff;
    color: #d61518;
    box-shadow: 0px 0px 10px #cccccc;
    -webkit-box-shadow: 0px 0px 10px #cccccc;
  }
  .paging{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/awards.vue